var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Box, Card, CircularProgress, Dialog, DialogContent, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Form from "@rjsf/mui";
import validator from '@rjsf/validator-ajv8';
import SettingsIcon from '@mui/icons-material/Settings';
import { Link } from "react-router-dom";
import ImagePicker from "./ImagePicker";
import Button from "@mui/material/Button";
import { ContentCategoryService } from "../services/contentCategory/contentCategory.service";
import { ServiceService } from "../services/service/service.service";
import { ContentService } from "../services/content/content.service";
import TextField from "@mui/material/TextField";
var AsyncPickerWidget = function (_a) {
    var fetchOptions = _a.fetchOptions, label = _a.label, value = _a.value, onChange = _a.onChange, id = _a.id;
    var _b = useState([]), options = _b[0], setOptions = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    useEffect(function () {
        fetchOptions()
            .then(function (res) {
            setOptions(res || []);
            setLoading(false);
        })
            .catch(function () { return setLoading(false); });
    }, []);
    var selectedOption = options.find(function (opt) { return opt.id === value; }) || null;
    return (_jsx(Autocomplete, { id: id, options: options, getOptionLabel: function (option) { return option.name || ""; }, value: selectedOption, onChange: function (_, newValue) { return onChange((newValue === null || newValue === void 0 ? void 0 : newValue.id) || ""); }, loading: loading, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { label: label, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(_Fragment, { children: [loading ? _jsx(CircularProgress, { size: 20 }) : null, params.InputProps.endAdornment] })) }) }))); } }));
};
// Content Category Picker
export var ContentCategoryPickerWidget = function (props) { return (_jsx(AsyncPickerWidget, __assign({}, props, { label: props.label || "Content Category", fetchOptions: function () { return __awaiter(void 0, void 0, void 0, function () {
        var results;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ContentCategoryService.getAllContentCategories({
                        limit: { offset: 0, limit: 5000 },
                    })];
                case 1:
                    results = _b.sent();
                    return [2 /*return*/, ((_a = results.content) === null || _a === void 0 ? void 0 : _a.map(function (i) {
                            return {
                                name: i.name,
                                id: i.id
                            };
                        })) || []];
            }
        });
    }); } }))); };
// Service Picker
export var ServicePickerWidget = function (props) { return (_jsx(AsyncPickerWidget, __assign({}, props, { label: props.label || "Service", fetchOptions: function () { return __awaiter(void 0, void 0, void 0, function () {
        var results;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ServiceService.getAllServices({
                        limit: { offset: 0, limit: 5000 },
                    })];
                case 1:
                    results = _b.sent();
                    return [2 /*return*/, ((_a = results.content) === null || _a === void 0 ? void 0 : _a.map(function (i) {
                            return {
                                name: i.name,
                                id: i.id
                            };
                        })) || []];
            }
        });
    }); } }))); };
// Content/Post Picker
export var ContentPickerWidget = function (props) { return (_jsx(AsyncPickerWidget, __assign({}, props, { label: props.label || "Content", fetchOptions: function () { return __awaiter(void 0, void 0, void 0, function () {
        var results;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ContentService.getAllContents({
                        limit: { offset: 0, limit: 5000 },
                    })];
                case 1:
                    results = _b.sent();
                    return [2 /*return*/, ((_a = results.content) === null || _a === void 0 ? void 0 : _a.map(function (i) {
                            return {
                                name: i.name,
                                id: i.id
                            };
                        })) || []];
            }
        });
    }); } }))); };
var INTERNAL_LINK_OPTIONS = [
    { value: "SaleCard", label: "SaleCard", description: "Opens feratel screen" },
    { value: "Webcam", label: "Webcam", description: "Opens webcam screen" },
    { value: "Explore", label: "Explore", description: "Opens Explore tab" },
    { value: "Calendar", label: "Calendar", description: "Opens Calendar tab" },
    { value: "Contact", label: "Contact", description: "Opens Contact tab" },
    { value: "Map", label: "Map", description: "Opens map screen" },
    { value: "TeamOverview", label: "TeamOverview", description: "Opens team screen" },
    { value: "Profile", label: "Profile", description: "Opens guest profile" },
    { value: "Overview", label: "Overview", description: "Opens Overview" },
    { value: "OnlineCheckIn", label: "OnlineCheckIn", description: "Opens check-in screen" },
    { value: "Stays", label: "Stays", description: "Opens my stays screen" },
    { value: "MyForsthofgutSimple", label: "MyForsthofgutSimple", description: "Opens daily point integration" },
    { value: "RoomBookingScreen", label: "RoomBookingScreen", description: "Opens booking engine" },
];
export var InternalLinkPickerWidget = function (props) {
    var value = props.value, onChange = props.onChange, id = props.id, label = props.label;
    var selectedOption = INTERNAL_LINK_OPTIONS.find(function (opt) { return opt.value === value; }) || null;
    return (_jsx(Autocomplete, { id: id, options: INTERNAL_LINK_OPTIONS, getOptionLabel: function (option) { return option.label; }, value: selectedOption, onChange: function (_, newValue) { return onChange((newValue === null || newValue === void 0 ? void 0 : newValue.value) || ""); }, renderOption: function (props, option) { return (_jsx(Box, __assign({ component: "li" }, props, { children: _jsxs(Box, { children: [_jsx(Typography, __assign({ variant: "body1", fontWeight: 500 }, { children: option.label })), _jsx(Typography, __assign({ variant: "caption", color: "text.secondary" }, { children: option.description }))] }) }))); }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { label: label || "Internal Screen", helperText: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.description }))); } }));
};
var ContentDataTagsEditor = function (props) {
    var _a, _b, _c, _d, _e;
    var t = useTranslation().t;
    var _f = useState(false), modifySchemaOpen = _f[0], setModifySchemaOpen = _f[1];
    var _g = useState(false), modifyUiSchemaOpen = _g[0], setModifyUiSchemaOpen = _g[1];
    var _h = useState(false), modifyRawData = _h[0], setModifyRawData = _h[1];
    var _j = useState(), tmpSchema = _j[0], setTmpSchema = _j[1];
    var _k = useState(), tmpUiSchema = _k[0], setTmpUiSchema = _k[1];
    var _l = useState(), tmpRawData = _l[0], setTmpRawData = _l[1];
    useEffect(function () {
        var _a, _b, _c;
        if (!props.data)
            return;
        if (!((_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b.tagSchema)) {
            var tagSchema = void 0;
            tagSchema = {
                type: 'object',
                additionalProperties: [
                    {
                        type: 'string'
                    }
                ],
                properties: {}
            };
            (_c = props.setData) === null || _c === void 0 ? void 0 : _c.call(props, __assign(__assign({}, props.data), { schema: __assign(__assign({}, props.data.schema), { tagSchema: tagSchema }) }));
        }
    }, [props.data]);
    if (!props.data)
        return null;
    var CustomFileWidget = function (props) {
        var _a;
        return (_jsxs(Stack, __assign({ id: props.id, sx: { alignItems: 'flex-start', gap: '6px' } }, { children: [_jsx(Typography, __assign({ variant: 'h6' }, { children: props.title || props.label })), _jsx(Typography, __assign({ variant: 'body2' }, { children: (_a = props.schema) === null || _a === void 0 ? void 0 : _a.description })), _jsx(ImagePicker, { image: props.value, setImage: function (media) {
                        props.onChange(media);
                    } })] })));
    };
    var widgets = {
        FileWidget: CustomFileWidget,
        "content-category-picker": ContentCategoryPickerWidget,
        "service-picker": ServicePickerWidget,
        "content-picker": ContentPickerWidget,
        "internal-link-picker": InternalLinkPickerWidget,
    };
    return (_jsxs(Card, __assign({ sx: { gap: '12px', maxWidth: '800px', backgroundColor: 'white', p: 2 }, variant: 'outlined' }, { children: [_jsxs(Stack, __assign({ direction: 'row', alignItems: 'center', p: 2 }, { children: [_jsx(Typography, __assign({ variant: 'h6' }, { children: t('Data') })), _jsx(Button, __assign({ startIcon: _jsx(SettingsIcon, {}), onClick: function () {
                            var _a, _b;
                            setModifySchemaOpen(true);
                            setTmpSchema(JSON.stringify((_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b.tagSchema, null, 2));
                        }, sx: { ml: 'auto' } }, { children: t('Data schema') })), _jsx(Button, __assign({ startIcon: _jsx(SettingsIcon, {}), onClick: function () {
                            var _a, _b;
                            setModifyUiSchemaOpen(true);
                            setTmpUiSchema(JSON.stringify((_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b.uiSchema, null, 2));
                        } }, { children: t('UI schema') })), _jsx(Button, __assign({ startIcon: _jsx(SettingsIcon, {}), onClick: function () {
                            var _a;
                            setModifyRawData(true);
                            setTmpRawData(JSON.stringify((_a = props.data) === null || _a === void 0 ? void 0 : _a.tags, null, 2));
                        } }, { children: t('Raw data') }))] })), _jsx(Form, { schema: ((_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b.tagSchema) || {}, formData: ((_c = props.data) === null || _c === void 0 ? void 0 : _c.tags) || {}, onChange: function (e) {
                    var _a;
                    (_a = props.setData) === null || _a === void 0 ? void 0 : _a.call(props, __assign(__assign({}, props.data), { tags: e.formData }));
                }, validator: validator, formContext: {
                    submit: false
                }, templates: {
                    ButtonTemplates: {
                        SubmitButton: function (props) { return _jsx("div", {}); }
                    }
                }, uiSchema: ((_e = (_d = props.data) === null || _d === void 0 ? void 0 : _d.schema) === null || _e === void 0 ? void 0 : _e.uiSchema) || {}, widgets: widgets }), _jsx(Dialog, __assign({ open: modifySchemaOpen, onClose: function () { return setModifySchemaOpen(false); }, fullWidth: true }, { children: _jsxs(DialogContent, __assign({ sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        alignItems: 'flex-start',
                        boxSizing: 'border-box',
                    } }, { children: [_jsxs(Stack, __assign({ sx: {
                                justifyContent: 'space-between',
                                width: '100%',
                                alignItems: 'center'
                            } }, { children: [_jsx(Typography, __assign({ variant: 'h6' }, { children: t('Data schema') })), _jsx(Link, __assign({ to: 'https://rjsf-team.github.io/react-jsonschema-form/', target: '_blank' }, { children: "Docs" }))] })), _jsx("textarea", { style: {
                                width: '95%'
                            }, rows: 30, value: tmpSchema, onChange: function (e) {
                                setTmpSchema(e.target.value);
                            } }), _jsx(Button, __assign({ variant: 'contained', disabled: (function () {
                                try {
                                    JSON.parse(tmpSchema || '{}');
                                    return false;
                                }
                                catch (e) {
                                    return true;
                                }
                            })(), onClick: function () {
                                var _a, _b;
                                (_a = props.setData) === null || _a === void 0 ? void 0 : _a.call(props, __assign(__assign({}, props.data), { schema: __assign(__assign({}, (_b = props.data) === null || _b === void 0 ? void 0 : _b.schema), { tagSchema: JSON.parse(tmpSchema || '{}') }) }));
                                setModifySchemaOpen(false);
                            } }, { children: t('Save') }))] })) })), _jsx(Dialog, __assign({ open: modifyUiSchemaOpen, onClose: function () { return setModifyUiSchemaOpen(false); }, fullWidth: true }, { children: _jsxs(DialogContent, __assign({ sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        alignItems: 'flex-start',
                        boxSizing: 'border-box',
                    } }, { children: [_jsxs(Stack, __assign({ sx: {
                                justifyContent: 'space-between',
                                width: '100%',
                                alignItems: 'center'
                            } }, { children: [_jsx(Typography, __assign({ variant: 'h6' }, { children: t('UI schema') })), _jsx(Link, __assign({ to: 'https://rjsf-team.github.io/react-jsonschema-form/', target: '_blank' }, { children: "Docs" }))] })), _jsx("textarea", { style: {
                                width: '95%'
                            }, rows: 30, value: tmpUiSchema, onChange: function (e) {
                                setTmpUiSchema(e.target.value);
                            } }), _jsx(Button, __assign({ variant: 'contained', disabled: (function () {
                                try {
                                    JSON.parse(tmpUiSchema || '{}');
                                    return false;
                                }
                                catch (e) {
                                    return true;
                                }
                            })(), onClick: function () {
                                var _a, _b;
                                (_a = props.setData) === null || _a === void 0 ? void 0 : _a.call(props, __assign(__assign({}, props.data), { schema: __assign(__assign({}, (_b = props.data) === null || _b === void 0 ? void 0 : _b.schema), { uiSchema: JSON.parse(tmpUiSchema || '{}') }) }));
                                setModifyUiSchemaOpen(false);
                            } }, { children: t('Save') }))] })) })), _jsx(Dialog, __assign({ open: modifyRawData, onClose: function () { return setModifyRawData(false); }, fullWidth: true }, { children: _jsxs(DialogContent, __assign({ sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        alignItems: 'flex-start',
                        boxSizing: 'border-box',
                    } }, { children: [_jsxs(Stack, __assign({ sx: {
                                justifyContent: 'space-between',
                                width: '100%',
                                alignItems: 'center'
                            } }, { children: [_jsx(Typography, __assign({ variant: 'h6' }, { children: t('Raw data') })), _jsx(Link, __assign({ to: 'https://rjsf-team.github.io/react-jsonschema-form/', target: '_blank' }, { children: "Docs" }))] })), _jsx("textarea", { style: {
                                width: '95%'
                            }, rows: 30, value: tmpRawData, onChange: function (e) {
                                setTmpRawData(e.target.value);
                            } }), _jsx(Button, __assign({ variant: 'contained', disabled: (function () {
                                try {
                                    JSON.parse(tmpRawData || '{}');
                                    return false;
                                }
                                catch (e) {
                                    return true;
                                }
                            })(), onClick: function () {
                                var _a;
                                (_a = props.setData) === null || _a === void 0 ? void 0 : _a.call(props, __assign(__assign({}, props.data), { tags: JSON.parse(tmpRawData || '{}') }));
                                setModifyRawData(false);
                            } }, { children: t('Save') }))] })) }))] })));
};
export default ContentDataTagsEditor;
